// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__1gXNz","image":"search_image__xyq48","data":"search_data__2KvZ_"};